// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-font-sans-serif: "HNforTELUSSA", sans-serif;
  --bs-body-font-family: "HNforTELUSSA", sans-serif;
  /* Shared light blue for hover/select states on list rows across the app */
  --list-hover-blue: #e8f4fd;
}

html,
body,
#root {
  font-family: "HNforTELUSSA", sans-serif !important;
  height: 100%;
  min-height: 100%;
}

body {
  margin: 0;
  padding: 0;
}

.disabled-card {
  cursor: not-allowed !important;
  color: rgba(181, 181, 181, 1) !important;
}

.disabled-card-menu-item {
  cursor: not-allowed !important;
  color: rgba(181, 181, 181, 1) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,0EAA0E;EAC1E,0BAA0B;AAC5B;;AAEA;;;EAGE,kDAAkD;EAClD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C","sourcesContent":[":root {\n  --bs-font-sans-serif: \"HNforTELUSSA\", sans-serif;\n  --bs-body-font-family: \"HNforTELUSSA\", sans-serif;\n  /* Shared light blue for hover/select states on list rows across the app */\n  --list-hover-blue: #e8f4fd;\n}\n\nhtml,\nbody,\n#root {\n  font-family: \"HNforTELUSSA\", sans-serif !important;\n  height: 100%;\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n.disabled-card {\n  cursor: not-allowed !important;\n  color: rgba(181, 181, 181, 1) !important;\n}\n\n.disabled-card-menu-item {\n  cursor: not-allowed !important;\n  color: rgba(181, 181, 181, 1) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
